import { useLocation } from "react-router-dom";
import { landingAppRoutes, mixedRoutes } from "~/constants";

type LocationType = "landingApp" | "mixed" | "memberApp";

export const useLocationType = (): LocationType => {
  const { pathname } = useLocation();

  const formattedPathname =
    pathname === "/" ? pathname : pathname.replace(/\/$/, "");

  const onLandingAppPage =
    landingAppRoutes.includes(formattedPathname as any) ||
    formattedPathname.includes("library") ||
    formattedPathname.includes("crew") ||
    formattedPathname.includes("dashboard") ||
    formattedPathname.includes("events");

  if (onLandingAppPage) return "landingApp";

  if (mixedRoutes.includes(formattedPathname as any)) return "mixed";

  return "memberApp";
};
